import React from "react";

export const PrivateLockBlue = () => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="private-lock"
    >
      <path
        d="M0 6C0 5.44772 0.447715 5 1 5H9C9.55228 5 10 5.44772 10 6V10C10 11.1046 9.10457 12 8 12H2C0.89543 12 0 11.1046 0 10V6Z"
        fill="white"
      />
      <path
        d="M1 3C1 1.34315 2.34315 0 4 0H6C7.65685 0 9 1.34315 9 3V6H1V3Z"
        fill="white"
      />
      <path
        d="M8.99805 6.00098H0.998047V9.95667C0.998047 10.4736 1.58613 11.001 2.00185 11.001H7.97397C8.57219 11.001 8.99805 10.5474 8.99805 9.93558V6.00098Z"
        fill="#317386"
      />
      <path
        d="M6.99806 5.00083L6.99798 4.00034C6.99798 1.00005 2.98835 0.999647 2.99811 3.99997L2.99805 5.00075"
        stroke="#317386"
        strokeWidth="2"
      />
    </svg>
  );
};

export const PrivateLockBlack = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="private-lock"
    >
      <path
        d="M8 6.00098H0V9.95667C0 10.4736 0.588086 11.001 1.0038 11.001H6.97592C7.57414 11.001 8 10.5474 8 9.93558V6.00098Z"
        fill="#000000"
      />
      <path
        d="M6.00001 5.00083L5.99993 4.00034C5.99993 1.00005 1.9903 0.999647 2.00007 3.99997L2 5.00075"
        stroke="#000000"
        strokeWidth="2"
      />
    </svg>
  );
};
